/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createGetMatrixDataType } from '../../factoriesAny.js';
export var getMatrixDataTypeDependencies = {
  typedDependencies,
  createGetMatrixDataType
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesGetMatrixDataType.generated.js
// module id = 1372
// module chunks = 2